<template>
  <div :class="iqosClass" :style="iqosStyles">
    <BaseHeader :style="iqosHeaderStyles" :color="overrideDividerColor || textAndLinesColor" v-if="hasTitleContent">
      <template #title>
        <slot name="title">{{ title }}</slot>
      </template>
      <template #actions>
        <slot name="actions"></slot>
      </template>
    </BaseHeader>
    <slot></slot>

    <div class="iqos-unavailable-overlay" v-if="isUnavailable"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,

    required: {
      type: Boolean,
      default: false
    },

    enabled: {
      type: Boolean,
      default: false
    },

    systemDependency: {
      type: String,
      default: null
    },

    backgroundColor: {
      type: String,
      default: null
    },
    overrideDividerColor: {
      type: String,
      default: null
    }
  },
  computed: {
    iqosClass() {
      return {
        'iqos': true,
        'iqos-required': this.required,
        'iqos-additional-disabled': !this.required && !this.enabled,
        'iqos-additional-enabled': !this.required && this.enabled,
        'iqos-unavailable': !!this.isUnavailable
      }
    },
    iqosHeaderStyles() {
      return {
        'color': `var(--${this.textAndLinesColor}-color)`
      }
    },
    iqosStyles() {
      if (!this.backgroundColor) return {};

      return {
        'background-color': `var(--${this.backgroundColor}-color)`
      }
    },
    textAndLinesColor() {
      return !this.required && this.enabled ? 'v1-grey-3' : 'v1-grey-10';
    },
    hasTitleContent() {
      return this.$slots.title || this.title;
    },
    isUnavailable() {
      if (!this.systemDependency) return false;

      return !this.$store.state.cafe.modes[this.systemDependency];
    }
  },
};
</script>

<style scoped>
.iqos {
  border-radius: 8px;
  padding: 16px;
  position: relative;
  box-sizing: border-box;
  width: 100%;
}

.iqos-required {
  background-color: var(--v1-grey-2-color);
}

.iqos-additional-disabled {
  background-color: transparent;
  border: 1px solid var(--v1-grey-10-color);
  padding: 15px;
}

.iqos-additional-enabled {
  background-color: var(--v1-grey-10-color);
}

.iqos-additional-enabled .iqos-comment {
  color: var(--v1-grey-6-color);
}

.iqos-unavailable {
  opacity: 0.5;
}

.iqos-unavailable-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: transparent;
  z-index: 5;
  cursor: not-allowed;
}
</style>
